import navList from './../../../assets/js/dashboard/nav'
import { openDB } from "idb"
import moment from "moment"
import Swal from "sweetalert2";

var salon_menu_tabs = [
    { "id": "main", "text": "" },
    { "id": "sub", "text": "" }
]

export{
    setReturnData, handleError,
    getOutletList, getOutletName,
    getIcon,getStaffList,
    getStateList,
    getCategoryList, getCategoryText, 
    getSubcategory,
    handleSessionExpired, 
    // getPermissionList,
    getBreadCrumbs,
    getCityList,
    setSalonMenuTabLabel,
    setCategoryLabel,
    setSalonMenuSubCategoryExportFields,
    setSummaryBoxLabel, idbOpen, toastrExe,
    addData,getData,setMemberList,getMemberMap
}

function setSalonMenuSubCategoryExportFields($vm){
    var ret = {}
    ret["#"] = "index"
    ret[($vm.$i18n.t('table.header.id', {'item': $vm.$i18n.t('label.subcategory')})).toUpperCase()] = "folderID"
    ret[($vm.$i18n.t('table.header.title')).toUpperCase()] = "title"
    ret[($vm.$i18n.t('table.header.category')).toUpperCase()] = "category"
    ret[($vm.$i18n.t('table.header.enable')).toUpperCase()] = "isEnable"
    return ret
}

function setSummaryBoxLabel($vm, type, item){
    for(var i=0 ; i<item.length; i++){
        item[i].text = $vm.$i18n.messages[$vm.$i18n.locale].salon_report[type][item[i].id]
    }
    return item
}

function setSalonMenuTabLabel(mainHeader, subHeader){
    for(var i = 0; i<salon_menu_tabs.length; i++){
        salon_menu_tabs[i].text = salon_menu_tabs[i].id == "main" ? mainHeader : subHeader
    }
    return salon_menu_tabs
}

function setCategoryLabel($vm, isCategory, label, item){
    var arr = []
    if(isCategory){
        arr.push({id: "all", text: label});
        for(var i=0; i<item.length; i++){
            arr.push({id: i, text: $vm.$i18n.t('label.category') + " " + (i+1) + " - " + item[i]});
        }

    }else{
        arr.push({
            id: "",
            text: label
        })
        arr.push(...item)
    }
    return arr
}

function getPermissionList($vm, permission){
    var permissionArr = []
    if(permission.indexOf('biz') != -1){
        var arrModule = permission.split(".")
        var module = arrModule[1]
        var subModule = arrModule[2]
        switch(module){
            case"member":
                permissionArr.push("navMySalon")
                permissionArr.push({id: "my_salon_member", text: $vm.$i18n.t('user.permission_list.my_salon_member')})
                break;
            case"user":
                permissionArr.push("navMySalon")
                
                if(subModule == "*"){
                    permissionArr.push({id: "my_salon_user", text: $vm.$i18n.t('user.permission_list.my_salon_user')})
                    permissionArr.push({id: "my_salon_user", text: $vm.$i18n.t('user.permission_list.all')})
                }else{
                    permissionArr.push({id: "my_salon_user_module", text: $vm.$i18n.t('user.permission_list.my_salon_user')})
                    switch(subModule){
                        case"add":
                        permissionArr.push({id: "my_salon_user_add", text: $vm.$i18n.t('user.permission_list.my_salon_user_add')})
                        break;
                        case"delete":
                        permissionArr.push({id: "my_salon_user_delete", text: $vm.$i18n.t('user.permission_list.my_salon_user_delete')})
                        break;
                        case"outlet":
                        permissionArr.push({id: "my_salon_user_outlet", text: $vm.$i18n.t('user.permission_list.my_salon_user_outlet')})
                        if(arrModule[3] == "*"){
                            permissionArr.push({id: "my_salon_user_outlet", text: $vm.$i18n.t('user.permission_list.all')})
                        }else{
                            permissionArr.push({id: "my_salon_user_outlet_permission", text: $vm.$i18n.t('user.permission_list.my_salon_user_outlet_permission')})
                        }
                        break;
                        case"permission":
                        permissionArr.push({id: "my_salon_user_permission", text: $vm.$i18n.t('user.permission_list.my_salon_user_permission')})
                        if(arrModule[3] == "*"){
                            permissionArr.push({id: "my_salon_user_permission", text: $vm.$i18n.t('user.permission_list.all')})
                        }
                        break;
                    }
                }
                break;
            case"outlets":
                permissionArr.push("navSalonSetting")
                permissionArr.push({id: "salon_setting_all_outlets", text: $vm.$i18n.t('user.permission_list.salon_setting_all_outlets')})
                if(subModule == "*") permissionArr.push({id: "salon_setting_all",  text: $vm.$i18n.t('user.permission_list.all')})
                break;
            case"report":
                permissionArr.push("navSalonReport")
                if(subModule == "*") permissionArr.push({id: "salon_report_all",  text: $vm.$i18n.t('user.permission_list.all')})
                break;
            case"menu":
                permissionArr.push("navSalonMenu")
                if(subModule == "*") permissionArr.push({id: "salon_menu_all",  text: $vm.$i18n.t('user.permission_list.all')})
                break;
            case"setting":
                permissionArr.push("navSalonSetting")
                if(subModule == "*") permissionArr.push({id: "salon_setting_all",  text: $vm.$i18n.t('user.permission_list.all')})
                break;
            case"appt":
                permissionArr.push("navMySalon")
                permissionArr.push({id: "my_salon_appointment_list", text: $vm.$i18n.t('subMenu.my_salon_appointment')})
                if(subModule == "view") permissionArr.push({id: "my_salon_appointment",  text:'View'})
                else if(subModule == "add")  permissionArr.push({id: "my_salon_appointment_add",  text:$vm.$i18n.t('header.add')})
                else if(subModule == "edit")  permissionArr.push({id: "my_salon_appointment_edit",  text:$vm.$i18n.t('header.edit')})
                break;
            case"dashboard":
                permissionArr.push("navDashboard")
                permissionArr.push({id: "navDashboard", text: $vm.$i18n.t('button_link.view')})
                break;
            case"message":
                permissionArr.push("navMySalon")
                permissionArr.push({id: "my_salon_message", text: 'Message'})
                break;
            case"branding":
                permissionArr.push("navMySalon")
                permissionArr.push({id: "my_salon_branding", text: 'Branding'})
                break;
            case"qsetup":
                permissionArr.push("navMySalon")
                permissionArr.push({id: "my_salon_setup", text: 'Quick Setup'})
                break;
            case"bcast":
                permissionArr.push("navMySalon")
                permissionArr.push({id: "my_salon_broadcast", text: 'Broadcast'})
                break;
            case"tukang":
                permissionArr.push("navMySalon")
                permissionArr.push({id: "my_salon_tukang", text:'Tukang'})
                break;     
        }
    }
    return permissionArr
}

function getStateList($vm){
    let QUERY_STRING =  "/state"
    const url =  $vm.$api.INFO + QUERY_STRING;

    $vm.$axios({
        method: 'get', 
        url: url,
        baseURL: $vm.$axios.defaults.baseURL, 
        headers: {token: $vm.$session.get('token')}
    })
    .then(function(response) {
        var results = response.data.result
        $vm.$store.commit('SET_INFO_STATE', results);
    })
    .catch((err) => {
        var error = err.response.data.error;
        if(error == "Invalid Token"){
            handleSessionExpired();   
        }
    })
}

async function getOutletList($vm){
    var outlets = [];
    const url = $vm.$api.BEBUSINESS_OUTLET;

    await $vm.$axios.get(url, {headers: {token: $vm.$store.state.token}})
    .then(function(response) {
        var results = response.data;
        for(var i=0; i<results.length; i++){
            outlets.push({id: results[i].outletID, text: results[i].loyalty.username, bizName: results[i].bizName})
        }
        outlets.sort((a, b) => a.id - b.id);
        $vm.$store.commit('SET_OUTLET', JSON.stringify(outlets));
    })
    .catch((err) => {
        var error = err.response.data.error;
        if(error == "Invalid Token"){
            handleSessionExpired();   
        }
    })
}

async function getStaffList($vm){
    let staffs = [];
    const url = "https://staff.tunai.io/business/staff/"

    await $vm.$axios.get(url, {headers: {token: $vm.$store.state.token}})
    .then(function(response) {
        staffs = response.data.staffs;
        staffs.sort((a, b) => a.staffID - b.staffID);
        $vm.$store.commit('SET_STAFF', JSON.stringify(staffs));
    })
    .catch((err) => {
        console.log(err)
        })
}

function getCategoryList($vm){
    const url = "https://m5.tunai.io/business/setting/menu/category";

    $vm.$axios.get(url, {headers: {token: $vm.$store.state.token}})
    .then(function(response) {
        var results = response.data;
        $vm.$store.commit('SET_CATEGORY', JSON.stringify(results));
    })
    .catch(() => {
    
    })
}

async function getSubcategory($vm, type, strFilter){
    type = type == "" ? "" : "?type=" + type
    const url = "https://m5.tunai.io/business/setting/menu/folder" + type + strFilter;

    var res = [];
    await $vm.$axios.get(url, {headers: {token: $vm.$session.get('token')}})
    .then(function(response) {
        var results = response.data.folder;
        for(var i=0; i<results.length; i++){
            res.push({id: results[i].folderID, text: results[i].title})
        }
        
    })
    .catch((err) => {
        var errData = err.response.data;
        if(errData.error == "Invalid Token"){
            handleSessionExpired();   
        }
    })
    return res;
}

function getCategoryText(id, category){
    var text = "";
    for(var i=0; i<category.length; i++){
        if(id == category[i].id){
            text = category[i].text;
            break;
        }
    }
    return text;
}

function getOutletName(id, outlet){
    var text = "";
    for(var i=0; i<outlet.length; i++){
        if(id == outlet[i].id){
            text = outlet[i].text;
            break;
        }
    }
    return text;
}

function setReturnData(data, count, page){
    var retData = {}
    retData['result'] = data;
    retData['count'] = count;
    
    var totalPage = Math.floor(count/100) + 1;
    retData['totalPage'] = totalPage
    
    var startPage = page * 100 + 1;
    retData['startPage'] = startPage;
    retData['endPage'] = (page + 1) == totalPage ? startPage + (data.length - 1)  : startPage + 99;

    return retData
}

function getIcon(type){
    var strClass = ""
    switch(type){
        case"service":
            strClass = "fa-user-cog";
            break;
        case"product":
            strClass = "fa-box-open";
            break;
        case"package":
            strClass = "fa-box-alt";
            break;
        case"discount":
            strClass = "fa-percent";
            break;
        case"outstandings":
            strClass = "fa-cart-plus";
            break;
    }
    return strClass
}

function handleError(error){
    var strError = ""
    switch(error){
        case"invalid base price":
            strError = "Invalid Base Price.";
            break;
        case"invalid price":
            strError = "Invalid Price.";
            break;
        default:
            strError = "System Error";
            break;
    }
    return strError
}

function handleSessionExpired(){
    document.getElementById('sessionExpiredModal').style.display = 'block';
    setTimeout(() => { document.getElementById('logout').click(); }, 2000);  
}
function toastrExe($vm,title, body, variant){
    $vm.$bvToast.toast(body, {
      title: title,
      variant: variant,
      solid: true,
    });
}
function getBreadCrumbs($vm, title){
    var sideNavs = navList.sideNavs
    var navObj = {
        id: "",
        icon: "",
        title: "",
        subMenu: []
    }
    var permissionArr = getPermissionList($vm, title)
    for (var i=0; i<sideNavs.length; i++){
        if(permissionArr[0] == sideNavs[i].id){
            navObj.id = sideNavs[i].id
            navObj.icon = sideNavs[i].icon
            navObj.title = $vm.$i18n.t(`sideNav.${sideNavs[i].id}`)
        }
    }
    for(var j=1; j<permissionArr.length; j++){
        navObj.subMenu.push(permissionArr[j])
    }
    return navObj
}

async function getCityList($vm){
    let QUERY_STRING =  "/city"
    const url =  $vm.$api.INFO + QUERY_STRING;

    var city = [];
    await $vm.$axios({
        method: 'get', 
        url: url,
        baseURL: $vm.$axios.defaults.baseURL, 
        headers: {token: $vm.$session.get('token')}
    })
    .then(function(response) {
        city = response.data.result
    })
    .catch((err) => {
        var error = err.response.data.error;
        if(error == "Invalid Token"){
            handleSessionExpired();   
        }
    })
    return city
}


async function idbOpen(dbName, dbObjectName){
    let localDatabase = await openDB(dbName, 1, {
        upgrade(db, oldVersion, newVersion, transaction, event) {
            db.createObjectStore(dbObjectName);
            console.log(`${dbName} local storage current version: ${newVersion}; Object store ${dbObjectName} has been created.`);
        },
    });
    return localDatabase;
}

async function addData(data,$vm) {
    const tx = $vm.db.transaction("member_list", "readwrite");
    const store = tx.objectStore("member_list");
    store.put(data, "key");
    const date = new Date();
    const unixTimestamp = Math.floor(date.getTime() / 1000);
    store.put(unixTimestamp, "timestamp");
    await tx.done;
}

async function getData($vm) {
    const tx = $vm.db.transaction("member_list", "readwrite");
    const store = tx.objectStore("member_list");
    const res = await store.get("key");
    return res;
}

async function setMemberList($vm){
    // const tx = $vm.db.transaction("member_list", "readwrite");
    // const store = tx.objectStore("member_list");
    // $vm.delta = await store.get("timestamp");
    // $vm.delta = $vm.delta == undefined ? 0 : $vm.delta;
    // const newData = await getMemberList($vm);
    // $vm.memberList = await getData($vm);
    // //$vm.setExportData();
    // if (newData.length != 0 || newData !== undefined || newData !== null) {
    //     $vm.memberList = $vm.memberList === undefined ? []:$vm.memberList;
    //     $vm.memberList = $vm.memberList.concat(newData);
    //     addData($vm.memberList,$vm);
    // }

    // $vm.memberData = $vm.memberList;
    // $vm.totalEntries = $vm.memberList.length;
}

// async function getMemberList($vm){
//     let url =
//         $vm.$api.MEMBER2 +
//         "?delta=" +
//         $vm.delta +
//         "&offset=" +
//         $vm.offset +
//         "&limit=" +
//         $vm.limit;
//     var result = [];
//     await $vm.$axios({
//         method: "get",
//         url: url,
//         headers: { token: $vm.$session.get("token") },
//     })
//     .then(function (response) {
//     result = response.data.members.map((m) => ({
//         ...m,
//         ...response.data.ethnics.find((e) => e.ethnicID === m.ethnicID),
//     }));
//     })
//     .catch((err) => {
//     var errData = err.response.data;
//     if (errData.error == $vm.$api.INVALID_TOKEN) {
//         handleSessionExpired();
//     }
//     });
//     return result;
// }

async function getMemberMap($vm) {
    if(!window.memberDB) {
        let userName = localStorage.getItem('userName')
        let dbName = userName + '_member_list';
        let dbObjectName = 'member_list'
        
        window.memberDB = await openDB(dbName, 1, {
            upgrade(db, oldVersion, newVersion, transaction, event) {
                console.log('upgrade oldVersion', oldVersion)
                console.log('upgrade newVersion', newVersion)
                db.createObjectStore(dbObjectName);
                console.log(`${dbName} local storage current version: ${newVersion}; Object store ${dbObjectName} has been created.`);
            },
            blocked(currentVersion, blockedVersion, event) {
                console.log('blocked currentVersion', currentVersion)
                console.log('blocked blockedVersion', blockedVersion)
            },
            blocking(currentVersion, blockedVersion, event) {
                console.log('blocking currentVersion', currentVersion)
                console.log('blocking blockedVersion', blockedVersion)
            },
            terminated() {
                console.log('terminated')
            },
        })
    }

    let tx = window.memberDB.transaction("member_list", "readwrite");
    let store = tx.objectStore("member_list");
    let delta = await store.get("timestamp") || 0
    let allMembers = await store.get("member") || {}
    let timestamp = moment().unix()

    // allMembers = {}
    // delta = 0

    if(delta === 0) {
        Swal.fire({
            icon: "loading",
            title: 'Loading Member Data',
            text: 'First time only',
            showSpinner: true,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });
    }

    let memberTotal = 0
    let offset
    do {
        let QUERY_STRING = '?delta=' + delta + '&limit=10000'
        if(offset) {
            QUERY_STRING += '&offset=' + offset
        }

        let result = await $vm.$axios({
            method: 'get',
            url: 'business/member' + QUERY_STRING,
            baseURL: $vm.$api.API_ENDPOINT_MEMBER,
            headers: { token: $vm.$session.get('token') }
        })
            .then((response) => {
                return response.data
            })
            .catch((err) => {
                Swal.close()
                
                var errData = err.response.data;
                if (errData.error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                }
            })

        for(let member of (result['members'] || [])) {
            allMembers[member['memberID']] = member
        }

        if(!result || !result['members'] || result['members'].length === 0) {
            break
        }

        memberTotal = result['total']
        offset = Object.keys(allMembers).length
    } while(offset < memberTotal)

    if(delta === 0) {
        Swal.close()
    }

    tx = window.memberDB.transaction("member_list", "readwrite");
    store = tx.objectStore("member_list");
    store.put(timestamp, "timestamp")
    store.put(allMembers, "member");                
    tx.done

    return allMembers
}